import {
  authorizedInstance as axios,
  authorizedPyInstance as pyAxios,
} from '~/utils';

const raceFetch = () =>
  pyAxios
    .get('api/data/reference/reference-race?sort=default-sort-order,race-name&page=1&page-size=1000')
    .then(r => r.data.data)
    .then(rs => rs.map(r => ({
      raceUid: r.id,
      raceName: r.attributes.raceName,
      raceLabel: r.attributes.raceLabel,
    })));

const genderFetch = () => axios
  .get('reference/gender')
  .then(r => r.data.data);

const genderIdentityFetch = () => pyAxios
  .get('api/data/reference/reference-gender-identity?sort=default-sort-order,gender-identity-label&page=1&page-size=1000')
  .then(r => r.data.data)
  .then(gis => gis.map(gi => ({
    genderIdentityUid: gi.id,
    genderIdentityName: gi.attributes.genderIdentityName,
    genderIdentityLabel: gi.attributes.genderIdentityLabel,
  })));

const referralSourceFetch = () => pyAxios
  .get('api/data/reference/reference-referral-source?sort=default-sort-order,referral-source-label&page=1&page-size=1000')
  .then(r => r.data.data)
  .then(refSource => refSource.map(r => ({
    referralSourceUid: r.id,
    name: r.attributes.referralSourceName,
    label: r.attributes.referralSourceLabel,
  })));

const referenceServices = {
  genderFetch,
  genderIdentityFetch,
  referralSourceFetch,
  raceFetch,
};

export default referenceServices;
